
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import axiosInstance from '../../../api/axiosInstance';

export const fetchWebsiteSettings = createAsyncThunk(
  'settings/fetchWebsiteSettings',
  async () => {
       // Fetch the baseURL from config.json
       const configResponse = await fetch('/config.json');
       const config = await configResponse.json();
       const baseURL = config.baseURL || process.env.REACT_APP_BASE_URL;
    const response = await axiosInstance.post(
      '/api/Common/GetWebsiteSettings',
      { websiteType: 3 ,
        linkType:10
      },
      { headers: { 'Content-Type': 'application/json-patch+json' } }
    );

    // Parse the response and map the FilePath to the full URL
    const parsedImages = JSON.parse(response.data.message);
    return parsedImages.map((item) => `${baseURL}/Upload${item.FilePath}`);
  }
);

const SliderSlice = createSlice({
  name: 'sliders',
  initialState: {
    images: [],
    imageChunks: [],
    status: 'idle',
    error: null,
  },
  reducers: {
    setImageChunks: (state, action) => {
      const chunks = [];
      const imagePaths = action.payload;
      for (let i = 0; i < imagePaths.length; i += 2) {
        chunks.push(imagePaths.slice(i, i + 2));
      }
      state.imageChunks = chunks;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchWebsiteSettings.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchWebsiteSettings.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.images = action.payload;

        // Automatically set chunks when data is fetched
        state.imageChunks = [];
        for (let i = 0; i < action.payload.length; i += 2) {
          state.imageChunks.push(action.payload.slice(i, i + 2));
        }
      })
      .addCase(fetchWebsiteSettings.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message;
      });
  },
});

export const { setImageChunks } = SliderSlice.actions;
export default SliderSlice.reducer;
